<template>
  <el-dialog
    title="Adicionar Arquivo"
    :visible.sync="visibility"
    :before-close="fechar"
    :modal-append-to-body="false"
    width="25%"
  >
    <el-form size="small" label-position="top">
      <el-form-item label="Descrição">
        <el-input v-model="descricao"/>
      </el-form-item>

      <el-form-item label="Localização Física">
        <el-input v-model="localizacaoFisica"/>
      </el-form-item>

      <el-form-item>
        <el-upload ref="upload" name="arquivo" :action="''" :limit="1" :auto-upload="false" class="file-upload-box">
          <el-button type="primary" slot="trigger" style="width: 100%" icon="el-icon-search">Selecionar Arquivo</el-button>
          <div slot="tip">jpg/png files with a size less than 500kb</div>
        </el-upload>
      </el-form-item>
    </el-form>

    <span slot="footer">
      <el-button type="success" size="small" @click="submitUpload" style="margin-left: 10px;">Upload</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import URLS from "../../util/urls.js";

export default {
  props: {
    visibility: Boolean,
    tipo: String
  },
  data() {
    return {
      descricao: "",
      localizacaoFisica: ""
    };
  },
  computed: {
    ...mapState('clientesStore', {
      cliente(state) { return state.clienteSelecionado; }
    }),
    ...mapState('imoveisStore', {
      imovel(state) { return state.imovelSelecionado; }
    }),
    ...mapState("vendasStore", {
      venda(state) { return state.vendaSelecionada; }
    }),
    url() { return URLS.ARQUIVOS_UPLOAD; }
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("clientesStore", ["uploadArquivoCliente"]),
    ...mapActions("imoveisStore", ["uploadArquivoImovel"]),
    ...mapActions("vendasStore", ["uploadArquivoVenda"]),
    reset() {
      this.descricao = "";
      this.localizacaoFisica = "";
      if(this.$refs.upload) { this.$refs.upload.clearFiles(); }
    },
    submitUpload() {
      let payload = new FormData();

      payload.append("arquivo", this.$refs.upload.uploadFiles[0].raw);
      payload.append("descricao", this.descricao);
      payload.append("localizacaoFisica", this.localizacaoFisica);

      if(this.tipo == "CLIENTE") { payload.append("idCliente", this.cliente.id); }
      if(this.tipo == "IMOVEL") { payload.append("idImovel", this.imovel.id); }
      if(this.tipo == "VENDA") { payload.append("idVenda", this.venda.id); }
      
      this.showLoading();
      if(this.tipo == "CLIENTE") {
        this.uploadArquivoCliente(payload)
          .then(resultado => {
            this.hideLoading();

            switch (resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                this.fechar();
                break;
              case "FALHA":
              case "ERRO":
                this.$message.error(resultado.mensagem);
                break;
            }
          })
          .catch(() => {
            this.hideLoading();
            this.$message.error("Ocorreu um erro");
          });
      }


      if(this.tipo == "IMOVEL") {
        this.uploadArquivoImovel(payload)
          .then(resultado => {
            this.hideLoading();

            switch (resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                this.fechar();
                break;
              case "FALHA":
              case "ERRO":
                this.$message.error(resultado.mensagem);
                break;
            }
          })
          .catch(() => {
            this.hideLoading();
            this.$message.error("Ocorreu um erro");
          });
      }

      if(this.tipo == "VENDA") {
        this.uploadArquivoVenda(payload)
          .then(resultado => {
            this.hideLoading();

            switch (resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                this.fechar();
                break;
              case "FALHA":
              case "ERRO":
                this.$message.error(resultado.mensagem);
                break;
            }
          })
          .catch(() => {
            this.hideLoading();
            this.$message.error("Ocorreu um erro");
          });
      }
    },
    fechar() {
      this.reset();
      this.$emit("close");
    }
  }
};
</script>

<style>
.file-upload-box .el-upload {
  margin-top: 5px;
  display: block !important;
}
</style>